function AMapUtil() {

    const _this = this;

    this.getAddress = function (geocoder, position) {
        return new Promise(function (resolve, reject) {
            geocoder.getAddress(position, function (status, result) {
                if (status === 'complete' && result.regeocode) {
                    const addressComponent = result.regeocode.addressComponent;
                    const formattedAddress = result.regeocode.formattedAddress;
                    const showAddress = formattedAddress
                        .replace(addressComponent.province, "")
                        .replace(addressComponent.city, "")
                        .replace(addressComponent.district, "")
                        .replace(addressComponent.township, "");
                    // console.error(showAddress);

                    resolve({
                        result: result,
                        success: true,
                        showAddress: showAddress,
                        adCode: addressComponent.adcode,
                        cityCode: addressComponent.citycode,
                        cityName: _this.getCityName(addressComponent),
                        districtName: addressComponent.district,
                    });
                } else {
                    reject(status);
                }
            });
        });
    };

    this.getCityName = function (addressComponent) {
        // console.log(JSON.stringify(addressComponent));
        if (addressComponent.district.length > 0 &&
            (addressComponent.district.endsWith("市")
                || addressComponent.district.endsWith("县"))) {
            return addressComponent.district;
        }
        if (addressComponent.city.length > 0) {
            return addressComponent.city;
        }
        if (addressComponent.province.length > 0) {
            return addressComponent.province;
        }
        return "未知地区";
    }
}

export default new AMapUtil();